// src/App.js
import React from 'react';
import './App.css';
import MatrixBackground from './components/MartixBackground';
import Terminal from './components/Terminal';
import Header from './components/Header';
import About from './components/About';


function App() {
  return (
    <>
      {/* Matrix background is rendered behind everything */}
      <MatrixBackground />
      
      <Header />
      <Terminal />
      <About />
      
    </>
  );
}

export default App;
